<template>
  <div>
    <header class="demos-header">
      <h1 class="demos-title">预约记录详情</h1>
    </header>
    <form id="reservationForm">
      <div id="reservation-row" class="weui-cells weui-cells_form">
        <div class="weui-cell" v-show="roleId !== config.RoleType.SUPPLIER">
          <div class="weui-cell__hd">
            <label class="weui-label">客户：</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              :value="respInfo.businessName"
              style="font-size: 16px"
              readonly="readonly"
            />
          </div>
        </div>

        <!-- <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" >物料类型：</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" :value="respInfo.materielType" readonly="readonly">
          </div>
        </div> -->

        <div
          class="weui-cell"
          v-show="
            respInfo.businessTypeId === config.BusinessTypeId.waste ||
            respInfo.businessTypeId === config.BusinessTypeId.veer
          "
        >
          <div class="weui-cell__hd">
            <label class="weui-label">操作类型：</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="respInfo.operType" readonly="readonly" />
          </div>
        </div>

        <div
          class="weui-cell"
          v-show="
            respInfo.businessTypeId === config.BusinessTypeId.waste ||
            respInfo.businessTypeId === config.BusinessTypeId.veer
          "
        >
          <div class="weui-cell__hd">
            <label class="weui-label">过磅类型：</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="weighType" readonly="readonly" />
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="productName">货物名称：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respInfo.materielName" class="weui-input" type="text" readonly="readonly" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="vehicleNo">车牌号：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respInfo.vehicleNo" class="weui-input" type="text" required="required" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="driverName">司机姓名：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respInfo.driverName" class="weui-input autocomplete-driver" type="text" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="phone">手机号：</label>
          </div>
          <div class="weui-cell__bd">
            <input
              v-model="respInfo.phone"
              class="weui-input autocomplete-mobilePhone"
              type="text"
              required="required"
            />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="verificationCode">验证码：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respInfo.verificationCode" class="weui-input" type="text" readonly="readonly" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label">上门日期：</label>
          </div>
          <div class="weui-cell__bd">
            <input :value="dateFormat(respInfo.appointedDate)" class="weui-input" type="text" readonly="readonly" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="idcard">身份证号：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respInfo.idcard" class="weui-input" type="text" />
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="idcard">预约量：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respInfo.materielList[0].predictQuantity" class="weui-input" type="text" />
          </div>
        </div>

        <div class="weui-cell" v-show="respInfo.businessTypeId === config.BusinessTypeId.veer">
          <div class="weui-cell__hd">
            <label class="weui-label">倒入地点：</label>
          </div>
          <div class="weui-cell__bd">
            <input :value="getPlace" class="weui-input" type="text" readonly="readonly" />
          </div>
        </div>

        <div class="weui-cell" v-show="respInfo.businessTypeId === config.BusinessTypeId.veer">
          <div class="weui-cell__hd">
            <label class="weui-label">倒出地点：</label>
          </div>
          <div class="weui-cell__bd">
            <input :value="outPlace" class="weui-input" type="text" readonly="readonly" />
          </div>
        </div>
      </div>
    </form>

    <div class="weui-cell">
      <div class="weui-cell__bd">
        <a
          v-if="
            (rolelimit == true && respInfo.logStatus === '010' && respInfo.rsvStatus != '3') ||
            (respInfo.logStatus === '010' && respInfo.rsvStatus == '0')
          "
          @click="handleEdit(respInfo)"
          class="weui-btn weui-btn_primary"
          >修改</a
        >
        <!-- v-if="respInfo.rsvStatus == '0' || respInfo.rsvStatus == '3'"-->
        <a
          v-if="
            (rolelimit == true && respInfo.logStatus === '010') ||
            (respInfo.logStatus === '010' && respInfo.rsvStatus == '0')
          "
          @click="handleDel(respInfo)"
          class="weui-btn weui-btn_primary"
          >删除</a
        >

        <a onclick="history.back()" class="weui-btn weui-btn_primary">返回</a>
        <a href="/" class="weui-btn weui-btn_primary">回到首页</a>
      </div>
    </div>
    <a-modal
      title="修改信息"
      style="top: 10px"
      :width="800"
      v-model="yyeditvisible"
      @ok="yyedithandleOk"
      destroyOnClose
      :confirmLoading="false"
    >
      <a-form :form="yyeditform">
        <a-form-item label="物流号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            placeholder="物流号"
            v-model="mdl.logisticsNo"
            v-decorator="[
              'logisticsNo',
              { initialValue: mdl.logisticsNo, rules: [{ required: true, message: '请输入物流号' }] },
            ]"
            v-bind:disabled="true"
          />
        </a-form-item>
        <a-form-item label="物料" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-select
            v-model="mdl.materielId"
            placeholder="请选择"
            v-decorator="[
              'materielId',
              { initialValue: mdl.materielId, rules: [{ required: true, message: '请选择物料' }] },
            ]"
          >
            <a-select-option v-for="(item, index) in materielSelect" :key="index" :value="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="车号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-auto-complete
            v-model="mdl.vehicleNo"
            :dataSource="vehicleNoList"
            style="max-width: 400px"
            placeholder=""
            :filterOption="filterOption"
            @change="(value) => changeVehicleNo(value)"
          />
          <!-- <a-input placeholder="车号" v-model="mdl.vehicleNo"  v-decorator="['vehicleNo', { initialValue: mdl.vehicleNo, rules: [{ required: true, message: '请输入车号'}]}]"/>-->
        </a-form-item>
        <a-form-item label="司机" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            placeholder="司机"
            v-model="mdl.driverName"
            v-decorator="[
              'driverName',
              { initialValue: mdl.driverName, rules: [{ required: true, message: '请输入司机' }] },
            ]"
          />
        </a-form-item>
        <a-form-item label="手机号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            placeholder="手机号"
            v-model="mdl.phone"
            v-decorator="['phone', { initialValue: mdl.phone, rules: [{ required: true, message: '请输入手机号' }] }]"
          />
        </a-form-item>

        <a-form-item label="预约量" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            placeholder="预约量"
            v-model="mdl.predictQuantity"
            v-decorator="[
              'predictQuantity',
              { initialValue: mdl.predictQuantity, rules: [{ required: true, message: '请输入预约量' }] },
            ]"
          />
        </a-form-item>

        <a-form-item label="上门日期" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-date-picker
            :defaultValue="defaultDate"
            v-model="mdl.appointedDate"
            v-decorator="[
              'appointedDate',
              { initialValue: mdl.appointedDate, rules: [{ required: true, message: '请输入上门日期' }] },
            ]"
            style="max-width: 150px"
            placeholder="请选择日期"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { reservationAdd, deleteReservation } from '@/api/logistics'
import { ytsoftBasicInfo, materielList, findscanquerybycarno, findAllByMark } from '@/api/basic'
import storage from "@/utils/storage"
import { showMsg } from '@/utils/util'
import { formatDate } from '@/utils/date.js'
import Bus from '@/layouts/bus'
import { yyedit } from '@/api/logistics'
import { findPrivileBycode } from '@/api/sys'
import moment from "moment";


export default {
  name: 'HelloWorld',
  data() {
    return {
      defaultDate: null,
      rolelimit: false,
      vehicleNoList: [],
      mdl: {},
      yyeditform: this.$form.createForm(this),
      yyeditvisible: false,
      selectedBizId: null,
      supplierSelect: null,
      roleId: null,
      materielData: {},
      materList: [],
      respInfo: {},
      ytBasicInfoList: [],
      weighType: '',
      getPlace: '',
      outPlace: ''
    }
  },
  created() {
    this.checkButtonPrivilege()
    this.roleId = this.$store.getters.roles
    let respInfoCache = storage.fetch("cache-respInfo");
    if (respInfoCache) {
      this.respInfo = JSON.parse(respInfoCache);
      if (this.respInfo.businessTypeId === this.config.BusinessTypeId.waste || this.respInfo.businessTypeId === this.config.BusinessTypeId.veer) {
        this.getBasicInfo()
      }
    }
  },

  methods: {
    //分配物流记录按钮权限
    checkButtonPrivilege() {

      new Promise(resolve => {
        const data = findPrivileBycode({ code: 'yyjl-handler' }).then(res => { return res.data })
        resolve(data)
      }).then(res => {

        if (res == 'yyjl-handler') {
          this.rolelimit = true
        }
      })

    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    changeVehicleNo(value, isUpperCase) {
      // 限制只能输入7位
      if (value.length > this.config.vehicleNoLength) {
        this.mdl.vehicleNo = value.substring(0, this.config.vehicleNoLength)
      }
      // 转换成大写
      if (isUpperCase === true && value.length >= 7) {
        this.mdl.vehicleNo = value.toUpperCase();
      }
      if (this.mdl.vehicleNo != '' && this.mdl.vehicleNo.length > 3) {
        //查询车子
        new Promise(resolve => {
          const data = findscanquerybycarno({
            vehicleNo: this.mdl.vehicleNo,
            logisticsNo: this.mdl.logisticsNo
          }).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.vehicleNoList = res

        })

        new Promise(resolve => {
          const data = findcarnoinfo({ vehicleNo: this.mdl.vehicleNo }).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.mdl.driverName = res.dname
          this.mdl.phone = res.phone

        })
      }
    },
    yyedithandleOk() {

      const kthis = this

      console.log(kthis.mdl.materielId + ":" + kthis.mdl.vehicleNo)
      yyedit(Object.assign({}, { materialid: kthis.mdl.materielId, vehicleno: kthis.mdl.vehicleNo, driver: kthis.mdl.driverName, tell: kthis.mdl.phone, logisticsNo: kthis.mdl.logisticsNo, appointedDate: kthis.mdl.appointedDate, predictQuantity: kthis.mdl.predictQuantity }))
        .then(res => {
          if (res.code === '0') {
            kthis.$refs.table.refresh()
          }
        })
        .catch(() => { })
        .finally(() => {
          kthis.yyeditvisible = false
          history.back()
        })
    },
    handleEdit(record) {
      new Promise(resolve => {
        const data = findAllByMark().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        console.log(record.vehicleNo);
        this.mdl = Object.assign({}, record)

        //每次打开弹窗之前重置下form表单
        this.yyeditform = this.$form.createForm(this)
        this.mdl.materielId = record.materielList[0].materielId
        this.mdl.predictQuantity = record.materielList[0].predictQuantity
        this.mdl.vehicleNo = record.vehicleNo
        this.mdl.appointedDate = moment(new Date(record.appointedDate), 'YYYY-MM-DD'),
          //console.log(record.materielList[0].materielId);
          this.materielSelect = res
        this.yyeditvisible = true
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          // nthis.confirmLoading = true
          return deleteReservation({ no: record.logisticsNo })
            .then(res => {
              if (res.code === '0') {
                //nthis.$refs.table.refresh()
                history.back()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {
              //nthis.confirmLoading = false
            })
        },
        onCancel() { }
      })
    },
    getWeighTypeName(value) {
      let obj = this.ytBasicInfoList.find((item) => {
        if (item.type === this.config.ytBaseInfoType.weigh_type_waste || item.type === this.config.ytBaseInfoType.weigh_type_veer)
          return item.id === value;
      });
      return obj.name
    },
    getPlaceName(value) {
      let obj = this.ytBasicInfoList.find((item) => {
        if (item.type === this.config.ytBaseInfoType.place_get_out)
          return item.id === value;
      });
      return obj.name
    },

    getBasicInfo() {
      ytsoftBasicInfo()
        .then(res => {
          if (res.code === '0') {
            this.ytBasicInfoList = res.data
            this.weighType = this.getWeighTypeName(this.respInfo.weighType)
            this.getPlace = this.getPlaceName(this.respInfo.getPlace)
            this.outPlace = this.getPlaceName(this.respInfo.outPlace)
          }
        }).catch((e) => {
          console.log(e)
        }).finally(() => {
        })
    },
    dateFormat(value) {
      return formatDate(new Date(value), 'yyyy-MM-dd')
    },
    addReservation() {
      if (!this.validate()) {
        return
      }
      const _this = this
      _this.confirmLoading = true
      Bus.$emit('showSpinning', true, "提交中...")
      let respList = []
      respList.push(this.respAddParam)
      reservationAdd(JSON.stringify(respList))
        .then(res => {
          if (res.code === '0') {
            showMsg('提交成功')
            this.$router.push({ name: 'wxRespList' })
          } else {
            showMsg(res.message)
          }
        }).catch((e) => {
          console.log(e)
        }).finally(() => {
          _this.confirmLoading = false
          Bus.$emit('showSpinning', false)
        })
    },
    changeDate(dates, dateStrings) {
      this.respAddParam.appointedDate = dateStrings
    },
    validate() {
      if (this.roleId !== this.config.RoleType.SUPPLIER && !this.respAddParam.corpSupplierId) {
        showMsg('供应商不能为空')
        return;
      }
      if (!this.respAddParam.businessTypeId) {
        showMsg('物料类型不能为空')
        return false
      }
      if (!this.respAddParam.materielId) {
        showMsg('物料不能为空')
        return false
      }
      if (!this.respAddParam.vehicleNo || !this.respAddParam.phone || !this.respAddParam.appointedDate) {
        showMsg('请完善预约信息')
        return false
      }
      if (this.respAddParam.vehicleNo.length != 7) {
        showMsg('车牌号必须为七位数')
        return false;
      }

      if (!this.config.Regex.telephone.test(this.respAddParam.phone)) {
        showMsg('手机号格式错误')
        return false
      }

      var today = new Date();
      var targetDate = new Date(this.respAddParam.appointedDate + " 23:59:59".replace("-", "/").replace("-", "/"));
      if (targetDate < today) {
        showMsg('上门日期不能小于当天')
        return false;
      }
      return true
    },

    toReservation() {
      this.$router.push({ name: 'wxRespAdd' })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>